import React, { Component } from 'react'
import { connect } from 'react-redux';
import { navNewURL } from './ActionUtils';
import './DialogNewContract.css';
import { selectMode } from './DialogNewContractActions';
import { closeOverlay } from './OverlayActions'
import './Common.css';
import { 
  CONDITIONAL_PAYMENT_LABEL,
  GENERAL_CONTRACT_LABEL,
  SEND_PAYMENT_LABEL,
  REQUEST_PAYMENT_LABEL
} from './Constants.js';

class DialogNewContract extends Component {

  constructor(props, context) {
    super(props);

    // This binding is necessary to make `this` work in the callback
    this.handleOk = this.handleOk.bind(this);
    this.selectMode = this.selectMode.bind(this);
    this.newContract = this.newContract.bind(this);
  }

  handleOk(name, value) {
    this.props.dispatch(closeOverlay());
  }
  
  selectMode(mode) {
    this.props.dispatch(selectMode(mode));
  }

  newContract(event, selectedUser, ownAccount) {
    event.preventDefault();
    let type = event.currentTarget.getAttribute("name");

    if (ownAccount) {
      this.props.dispatch(navNewURL('/new?type=' + type));
    }
    else {
      this.props.dispatch(navNewURL('/new?user=' + encodeURIComponent(selectedUser) + '&type=' + type));
    }

    this.handleOk(type);
  }
  
  render() {
    
    let {
      selectedUser="",
      mode=""
    } = this.props.dialogNewContract;

    let {
      username=""
    } = this.props.auth;

    let ownAccount = selectedUser === "" || username === selectedUser;

    return (
      <div className="publicDialogContent newContractDialog">
        <header className="publicDialogHeader"><h2 id="public-dialog-title">{!ownAccount ? "New contract with " + selectedUser : "New contract"}</h2></header>
        <div className="publicDialogBody">
          {mode === "start" && (
            <div>
              <p className="contractChoiceQuestion">
                What type of contract?
              </p>
              <div className="contractChoices">
                <button type="button" className="contractChoice" onClick={() => this.selectMode("payment")}><span>{CONDITIONAL_PAYMENT_LABEL}</span><span aria-hidden="true">→</span></button>
                <button type="button" name="contract" className="contractChoice" onClick={(event) => this.newContract(event, selectedUser, ownAccount)}><span>{GENERAL_CONTRACT_LABEL}</span><span aria-hidden="true">→</span></button>
              </div>
              <p className="contractChoiceNote">
                If only one person will deposit funds choose 'conditional payment', otherwise choose 'general contract'.
              </p>
            </div>
          )}
          {mode === "payment" && (
            <div>
              <p className="contractChoiceQuestion">
                Will you send or request the conditional payment?
              </p>
              <div className="contractChoices">
                <button type="button" name="payment" className="contractChoice" onClick={(event) => this.newContract(event, selectedUser, ownAccount)}><span>{SEND_PAYMENT_LABEL}</span><span aria-hidden="true">↗</span></button>
                <button type="button" name="request" className="contractChoice" onClick={(event) => this.newContract(event, selectedUser, ownAccount)}><span>{REQUEST_PAYMENT_LABEL}</span><span aria-hidden="true">↙</span></button>
              </div>
              <button type="button" className="publicDialogTextButton contractChoiceBack" onClick={() => this.selectMode("start")}>← Back</button>
            </div>
          )}
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    auth: state.auth,
    menu: state.menu,
    dialogNewContract: state.dialogNewContract
  }
}

const DialogNewContractContainer = connect(mapStateToProps, null)(DialogNewContract);
export default DialogNewContractContainer;
